import { Card, CardHeader, Typography, Button } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../../app/slices/supplierSlice";
import BannerForm from "../../form";
import { BiImport } from "react-icons/bi";


const SupplierHeader = () => {
  const  _Supplier  = useSelector((state) => state.supplier);
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
              الموردين
          </Typography>
        }
        avatar={<BiImport size={20} />}
        action={
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<IoIosAddCircleOutline />}
            onClick={() => dispatch(setDialog())}
          >
            إضافة مورد جديد
          </Button>
        }
      />
      {_Supplier.supplier.dialog ? <BannerForm /> : null}
    </Card>
  );
};

export default SupplierHeader;
